import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Scissors } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const EmailPatternFilterNode = ({ data, selected }: NodeProps) => {
    return (
        <BaseNodeUI
            title={data.label || "Email Pattern"}
            icon={Scissors}
            colorClass="text-pink-600"
            bgClass="bg-pink-100"
            selected={selected}
            isRunning={data?.executionStatus === 'Running'} executionStatus={data?.executionStatus}
            rowsProcessed={data?.rowsAffected}
        />
    );
};

export default memo(EmailPatternFilterNode);
